import { createContext } from 'react';

const AppConfigContext = createContext();

export { AppConfigContext };
